import React from "react";
import { compose } from "recompose";
import { trackProps, withTrack } from "@dpdgroupuk/react-event-tracker";
import PropTypes from "prop-types";
import { Page } from "@dpdgroupuk/mydpd-ui";

import { GENERAL_VIEW } from "../../constants/analytics";
import { CollectionTypes } from "../../models/types";
import Delimiter from "../../components/Delimiter";
import CollectionStatus from "./components/CollectionStatus";
import CollectionDetails from "./components/CollectionDetails";
import CollectionHistory from "./components/CollectionHistory";
import ShipmentDetails from "./components/ShipmentDetails";
import { getPageTitle } from "./model";
import { useAuthUser } from "../../components/AuthUser";

const GeneralView = ({ collection, children, ...rest }) => {
  const { username } = useAuthUser();
  return (
    <Page title={getPageTitle(collection)} username={username}>
      <Page.Section>
        <CollectionStatus collection={collection} />
        <CollectionDetails collection={collection} />
      </Page.Section>
      <Delimiter />
      {React.cloneElement(children, { ...rest })}
      <Delimiter />
      {collection.collectionEvents.length > 0 && (
        <>
          <Page.Section title="Collection History" closable>
            <CollectionHistory data={collection.collectionEvents} />
          </Page.Section>
          <Delimiter />
        </>
      )}
      {collection.deliveries.length > 0 && (
        <>
          <Page.Section title="Shipment Details">
            <ShipmentDetails deliveries={collection.deliveries} />
          </Page.Section>
          <Delimiter />
        </>
      )}
    </Page>
  );
};

GeneralView.propTypes = {
  collection: PropTypes.shape(CollectionTypes.Collection),
  children: PropTypes.node,
};

export default compose(withTrack(trackProps(GENERAL_VIEW)))(GeneralView);
